import styles from './infoCircleTooltip.module.scss';
import { Tooltip } from 'react-tooltip';

function InfoCircleTooltip({
  text,
  id,
  variant = 'info',
}: {
  text: string;
  id: string;
  variant?: 'info' | 'warning' | 'error';
}) {
  return (
    <div className={styles.container}>
      <i data-tooltip-id={id} className={`fas fa-info-circle fa-sm ${styles[`${variant}Icon`]}`} />
      <Tooltip id={id} place='right' className={styles.tooltip} variant={variant}>
        <div className={styles.tooltipText}>{text}</div>
      </Tooltip>
    </div>
  );
}

export default InfoCircleTooltip;
